export default "__VITE_ASSET__C4I4lVyE__"